import angular from 'angular';
import _findIndex from 'lodash/findIndex';
/**
 * @desc  RealizationService class.
 */
var RealizationService = /** @class */ (function () {
    function RealizationService($rootScope, $q, $log, $http, moment) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$log = $log;
        this.$http = $http;
        this.moment = moment;
        this.realizations = [];
        this.$rootScope.$on('scr.select', function () {
            _this.realizations.splice(0, _this.realizations.length);
        });
    }
    RealizationService.prototype.add = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var copyRealization = {};
        angular.copy(options.data, copyRealization);
        var url = "/SCR/employee/".concat(this.$rootScope.me.employeeId);
        if (angular.isDefined(options.data.substituteActivityId)) {
            url += '/substituteRealizations';
        }
        else {
            url += '/realizations';
        }
        return this.$http({
            method: 'POST',
            url: url,
            data: options.data
        }).then(function (result) {
            copyRealization.id = result.data.id;
            if (options.addToLocal) {
                copyRealization.employee = _this.$rootScope.me;
                copyRealization.employee.fullName = _this.$rootScope.me.name;
                _this.realizations.unshift(copyRealization);
            }
            return true;
        }, function (err) { return _this.$q.reject(err); });
    };
    RealizationService.prototype.getByEmployee = function (params, id) {
        var _this = this;
        if (params === void 0) { params = {}; }
        if (id === void 0) { id = 0; }
        var employeeId = this.$rootScope.me.employeeId;
        if (id > 0) {
            employeeId = id;
        }
        return this.$http({
            method: 'GET',
            url: "/SCR/employee/".concat(employeeId, "/realizations"),
            params: {
                dateFrom: params.dateFrom,
                dateTo: params.dateTo,
                limit: params.limit,
                offset: params.offset
            }
        }).then(function (result) {
            if (result.data.realizations.length > 0) {
                result.data.realizations.forEach(function (realization, index) {
                    realization.index = index + 1;
                    realization.formatDate =
                        _this.moment(realization.date).format('dddd') +
                            ' (' +
                            _this.moment(realization.date).format('DD.MM.YYYY') +
                            ')';
                });
            }
            _this.realizations = result.data.realizations;
            return result;
        }, function (err) { return _this.$q.reject(err); });
    };
    RealizationService.prototype.getByGroup = function (params) {
        var _this = this;
        if (params === void 0) { params = {}; }
        return this.$http({
            method: 'GET',
            url: "/SCR/group/".concat(params.groupId, "/realizations"),
            params: {
                dateFrom: params.dateFrom,
                dateTo: params.dateTo,
                limit: params.limit,
                offset: params.offset
            }
        }).then(function (result) {
            if (result.data.realizations.length > 0) {
                result.data.realizations.forEach(function (realization, index) {
                    realization.index = index + 1;
                    realization.formatDate =
                        _this.moment(realization.date).format('dddd') +
                            ' (' +
                            _this.moment(realization.date).format('DD.MM.YYYY') +
                            ')';
                });
            }
            _this.realizations = result.data.realizations;
            return result;
        }, function (err) { return _this.$q.reject(err); });
    };
    RealizationService.prototype.get = function (id) {
        var _this = this;
        return this.$http({
            method: 'GET',
            url: "/SCR/employee/".concat(this.$rootScope.me.employeeId, "/realizations/").concat(id)
        }).then(function (result) { return result.data.realization; }, function (err) { return _this.$q.reject(err); });
    };
    RealizationService.prototype.edit = function (data) {
        var _this = this;
        if (data === void 0) { data = {}; }
        var copyRealization = {};
        angular.copy(data, copyRealization);
        var url = "/SCR/employee/".concat(this.$rootScope.me.employeeId);
        var dataObj = data;
        if (data.realization.substituteActivity) {
            url += '/substituteRealizations/';
            dataObj = data.realization;
        }
        else {
            url += '/realizations/';
        }
        return this.$http({
            method: 'PUT',
            url: url + data.realization.id,
            data: dataObj
        }).then(function () { return true; }, function (err) { return _this.$q.reject(err); });
    };
    RealizationService.prototype.delete = function (data) {
        var _this = this;
        if (data === void 0) { data = {}; }
        var url = "/SCR/employee/".concat(this.$rootScope.me.employeeId);
        if (data.isSubstituteRealization) {
            url += '/substituteRealizations/';
        }
        else {
            url += '/realizations/';
        }
        return this.$http({
            method: 'DELETE',
            url: url + data.id
        }).then(function (result) {
            var idToRemove = _findIndex(_this.realizations, ['id', data.id]);
            if (idToRemove > -1) {
                _this.realizations.splice(idToRemove, 1);
            }
            return result;
        }, function (err) { return _this.$q.reject(err); });
    };
    /**
     * Constructor of the class.
     *
     * @param {$rootScope} $rootScope
     * @param {$q} $q
     * @param {$log}  $log
     * @param {$http} $http
     * @param {moment} moment
     */
    RealizationService.$inject = ['$rootScope', '$q', '$log', '$http', 'moment'];
    return RealizationService;
}());
export default RealizationService;
